<template>
                <div v-if="currentView === 'logs'">
                    <div class="page-header">
                        <div><div class="page-title">郵件日誌</div><div class="page-subtitle">查看所有進出郵件的傳遞紀錄與狀態</div></div>
                    </div>
                    <div class="card p-6">
                        <table class="data-table">
                            <thead>
                                <tr class="border-b" style="background:var(--gray-50);">
                                    <th class="p-2">時間</th>
                                    <th class="p-2">寄件者</th>
                                    <th class="p-2">收件者</th>
                                    <th class="p-2">狀態</th>
                                    <th class="p-2">垃圾郵件分數</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(log, idx) in safeArr(logs)" :key="keyById(log, 'log', idx)" class="border-b">
                                    <td class="p-2">{{ new Date(log.timestamp).toLocaleString() }}</td>
                                    <td class="p-2">{{ log.sender }}</td>
                                    <td class="p-2">{{ log.recipient }}</td>
                                    <td class="p-2">
                                        <span class="px-2 py-0.5 rounded text-xs"
                                            :style="log.status === 'sent' ? 'background:var(--success);color:#fff;' : 'background:var(--warning);color:#fff;'">{{
                                            log.status }}</span>
                                    </td>
                                    <td class="p-2">{{ log.spam_score }}</td>
                                </tr>
                                <tr v-if="logs.length === 0">
                                    <td colspan="5" class="p-4 text-center" style="color:var(--gray-500);">找不到日誌。</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useAppStore } from '../store/app.js'

const store = useAppStore()
const stateRefs = storeToRefs(store)

// Spread all commonly needed state refs
const {
  token, currentView, currentUser, loginForm, loginError,
  branding, notifications, showNotifPanel,
  showCmdPalette, cmdQuery, cmdResults, cmdGrouped, cmdDefaults, cmdSelIdx,
  domains, domainForm, showDomainForm, domainLoading,
  users, userForm, showUserForm, userLoading, userError,
  departments, deptForm, showDeptForm, deptLoading,
  contacts, contactForm, showContactForm, contactLoading,
  groups, groupForm, showGroupForm, groupLoading,
  mailQueues, mailQueueLoading, mailQueueFilter,
  serviceStatus, serviceLoading,
  invoiceDriveState,
  quotes, quoteForm, showQuoteForm, quoteLoading,
  products, productForm, showProductForm, productLoading,
  priceBooks, priceBookForm, showPriceBookForm,
  sslCerts, sslLoading, sslDomain,
  securityWizardStep, spamStats, securityFilterState,
  serverMailSettings, serverDnsSettings, serverDbSettings, serverAiSettings,
  backupSettings,
  logs, logFilter, logLoading,
  mailAuditRecords, auditFilter, auditLoading,
  securityAuditLogs, securityAuditFilter,
  logAnalysisResult, logAnalysisLoading,
  ragState, aiSalesState, aiMarketingState,
  lineSupportState,
  webmailState, webmailAutoScanInvoices, webmailAutoScanMarkRead,
  unrepliedEmails, unrepliedLoading,
  cbiInsights, cbiLoading,
  sidebarCollapsed, sidebarMobile,
  journeyEnrollments, journeyEnrollmentsLoading,
  journeyFunnel, journeyFunnelLoading, journeyFunnelFilters,
  showJourneyEditorModal, showJourneyFunnelModal, showJourneyEnrollmentsModal,
  selectedJourneyForEnrollments, selectedJourneyForFunnel,
  journeyEditorForm,
  showQuarantineModal, showQuarantineMapModal,
  quarantineMode, quarantineFolder, quarantineFolders,
  quarantineScanFolder, quarantineScanLimit,
  quarantineScanPhishingThreshold, quarantineScanSpamThreshold,
  quarantineLoading, quarantineItems, quarantineTotal,
  quarantineMapText, quarantineMapError, quarantineMapLoading,
} = stateRefs

// Methods accessed directly from store
const {
  login, logout, switchSidebarView, canAccess,
  openCommandPalette, closeCmdPalette, updateCmdResults, execCmdItemById,
  moveCmdSel, toggleNotifPanel, markNotifRead, clearNotifs,
  fetchDomains, saveDomain, deleteDomain,
  fetchUsers, saveUser, deleteUser, resetUserPassword,
  fetchDepartments, saveDepartment, deleteDepartment,
  fetchContacts, saveContact, deleteContact, importContacts,
  fetchGroups, saveGroup, deleteGroup,
  fetchMailQueue, releaseMailQueueItem, deleteMailQueueItem, flushMailQueue,
  fetchServiceStatus, fetchSpamStats,
  fetchSslCerts, issueSslCert, deleteSslCert,
  fetchProducts, saveProduct, deleteProduct,
  fetchPriceBooks, savePriceBook, deletePriceBook,
  fetchQuotes, saveQuote, deleteQuote, sendQuote,
  fetchLogs, fetchLogAnalysis,
  fetchMailAuditRecords, fetchSecurityAuditLogs,
  fetchServerMailSettings, saveServerMailSettings,
  fetchServerDnsSettings, saveServerDnsSettings,
  fetchServerDbSettings, saveServerDbSettings,
  fetchServerAiSettings, saveServerAiSettings,
  fetchBackupSettings, saveBackupSettings, triggerBackup,
  fetchSecurityFilter, saveSecurityFilter,
  fetchRagDocuments, uploadRagDocument, deleteRagDocument, queryRag,
  fetchUnreplied, fetchUnrepliedMessages, followUpUnreplied,
  fetchCbiInsights,
  loadBrandingFromLocal, saveBranding,
  safeArr, keyById,
  invoiceDriveCanGotoAdjacent, invoiceDriveGotoAdjacent,
  openInvoiceDetail, closeInvoiceDetail,
  openQuarantineModal, closeQuarantineModal, scanQuarantine, releaseQuarantineItem, deleteQuarantineItem,
  openQuarantineMapModal, closeQuarantineMapModal, saveQuarantineMapModal,
  openNotificationsModal, refreshAiSales, scanInboundReplies,
  autoRepliesScanLoading,
} = store
</script>

